module.exports = __webpack_public_path__ + "img/share.85274ee7.svg";